/** Leest zowel een Firestore-tijdstempel als een kale milliseconde-waarde. */
const toMillis = (value) => {
    if (value === null || value === undefined) return null
    if (typeof value === 'number') return Number.isFinite(value) ? value : null
    if (typeof value.toMillis === 'function') return value.toMillis()
    if (typeof value.toDate === 'function') return value.toDate().getTime()
    return null
}

/**
 * @typedef {object} StatusHistoryRow
 * @property {string} ID - Id van de logregel
 * @property {string} from - Label van de status ervoor; leeg bij de beginregel
 * @property {string} to - Label van de status erna
 * @property {boolean} isStart - Of dit de beginregel van het traject is
 * @property {number|null} changedAt - Tijdstip in ms; null zolang de server het nog moet vastleggen
 * @property {string} by - Naam van wie de wissel deed; leeg als die onbekend is
 */

/**
 * Zet ruwe StatusHistory-documenten om in regels voor het scherm, nieuwste
 * bovenaan. Puur — de aanroeper haalt de documenten en de namen op.
 *
 * Een regel waarvan de servertijd nog niet is geland (`ChangedAt` is null in de
 * eerste lokale snapshot) komt bovenaan: dat is juist de zojuist geschreven
 * wissel.
 *
 * @param {Array<object>} entries - StatusHistory-documenten van één entiteit
 * @param {object} options
 * @param {Record<string, string>} [options.statusLabels] - Statussleutel naar label
 * @param {Record<string, string>} [options.userNames] - Users.ID naar naam
 * @returns {Array<StatusHistoryRow>}
 */
const buildStatusHistoryRows = (entries, { statusLabels, userNames } = {}) => {
    const labels = statusLabels || {}
    const names = userNames || {}

    const label = (status) => (status ? labels[status] || status : '')

    return (entries || [])
        .map((item) => ({
            ID: item.ID,
            from: label(item.FromStatus),
            to: label(item.ToStatus),
            isStart: !item.FromStatus,
            changedAt: toMillis(item.ChangedAt),
            by: names[item.ChangedBy] || '',
        }))
        .sort((a, b) => {
            if (a.changedAt === null && b.changedAt === null) return 0
            if (a.changedAt === null) return -1
            if (b.changedAt === null) return 1
            return b.changedAt - a.changedAt
        })
}

export default buildStatusHistoryRows
